var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "c-step-by-step-guide__step t-margin-bottom-m",
      attrs: { id: "step-" + _vm.id }
    },
    [
      _c("header", { staticClass: "c-step-by-step-guide__step-header" }, [
        _c("span", { staticClass: "c-step-by-step-guide__step-number" }, [
          _vm._v("Steg " + _vm._s(_vm.index + 1))
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "c-step-by-step-guide__step-heading" }, [
          _vm._v(_vm._s(_vm.heading))
        ])
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "c-step-by-step-guide__step-content",
        domProps: { innerHTML: _vm._s(_vm.text) }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "c-step-by-step-guide__step-options" },
        [
          _vm._l(_vm.options, function(option) {
            return _vm.optionsType === "buttons"
              ? [
                  option.type === "GuideStep"
                    ? _c(
                        "button",
                        {
                          class:
                            "c-button c-button--secondary " +
                            (_vm.selectedOption === option.id
                              ? "selected"
                              : ""),
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.fetchStep(option.id, option.text)
                            }
                          }
                        },
                        [_vm._v(_vm._s(option.text))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  option.type === "Link" && option.url
                    ? _c(
                        "a",
                        {
                          staticClass: "c-button c-button--secondary",
                          attrs: { href: option.url }
                        },
                        [_vm._v(_vm._s(option.text))]
                      )
                    : _vm._e()
                ]
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.optionsType === "radio"
            ? _c(
                "fieldset",
                { staticClass: "c-radio-group" },
                [
                  _vm._l(_vm.options, function(option) {
                    return [
                      option.type === "GuideStep"
                        ? _c("div", { staticClass: "c-radio" }, [
                            _c("input", {
                              staticClass: "c-radio__input",
                              attrs: {
                                type: "radio",
                                name: "radio",
                                id: option.id
                              },
                              domProps: {
                                checked:
                                  _vm.selectedOption === option.id
                                    ? "selected"
                                    : false
                              },
                              on: {
                                change: function($event) {
                                  return _vm.fetchStep(option.id, option.text)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "c-radio__label",
                                attrs: { for: option.id }
                              },
                              [_vm._v(_vm._s(option.text))]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      option.type === "Link" && option.url
                        ? _c("p", [
                            _c("a", { attrs: { href: option.url } }, [
                              _vm._v(_vm._s(option.text))
                            ])
                          ])
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }